import React from 'react';
import { TeamPermission } from 'nekst-api';
import MarketsList from './MarketsList';
import AccessChecker from '../../../shared/authorization/AccessChecker';

export default function SetupAreasAdminPage() {
  return (
    <AccessChecker permissionToCheck={TeamPermission.MANAGE_MARKETS}>
      <MarketsList />
    </AccessChecker>
  );
}
